import { useState, useEffect } from 'react';
import { useSupabaseClient, useUser } from '@supabase/auth-helpers-react';

export const useProfile = () => {
  const supabase = useSupabaseClient();
  const user = useUser();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    if (user) {
      fetchProfile();
    }
  }, [user]);

  const fetchProfile = async () => {
    try {
      setLoading(true);
      setError(null);

      const { data, error } = await supabase
        .from('profiles')
        .select(`
          id,
          first_name,
          last_name,
          full_name,
          phone_number,
          is_administrator,
          is_message_sender,
          is_superadmin,
          created_at,
          updated_at
        `)
        .eq('id', user.id)
        .maybeSingle();

      if (error) {
        if (error.code === 'PGRST116') {
          setProfile(null);
          return;
        }
        throw error;
      }

      setProfile(data);
    } catch (err) {
      if (err.code !== 'PGRST116') {
        setError(err.message);
        console.error('Error fetching profile:', err);
      }
    } finally {
      setLoading(false);
    }
  };

  const createProfile = async (profileData) => {
    try {
      setError(null);
      const { data, error } = await supabase
        .from('profiles')
        .insert([{ 
          id: user.id,
          ...profileData,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString()
        }])
        .select()
        .single();

      if (error) throw error;
      
      setProfile(data);
      return { error: null };
    } catch (err) {
      setError(err.message);
      console.error('Error creating profile:', err);
      return { error: err };
    }
  };

  const updateProfile = async (updates) => {
    try {
      setError(null);
      const { data, error } = await supabase
        .from('profiles')
        .update({
          ...updates,
          updated_at: new Date().toISOString()
        })
        .eq('id', user.id)
        .select()
        .single();

      if (error) throw error;
      
      setProfile(data);
      return { error: null };
    } catch (err) {
      setError(err.message);
      console.error('Error updating profile:', err);
      return { error: err };
    }
  };

  return {
    profile,
    loading,
    error,
    createProfile,
    updateProfile,
    fetchProfile
  };
};

// Helper functions for phone number formatting
export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return '';
  const digits = phoneNumber.replace(/\D/g, '');
  return digits.length === 10 ? `+1${digits}` : digits;
};

export const displayPhoneNumber = (phoneNumber) => {
  console.log('displayPhoneNumber input:', phoneNumber);
  if (!phoneNumber) return '';
  // Remove any non-digit characters and the +1 prefix if present
  const digits = phoneNumber.replace(/\D/g, '').replace(/^1/, '');
  console.log('After cleaning digits:', digits);
  if (digits.length === 10) {
    const formatted = `(${digits.slice(0,3)}) ${digits.slice(3,6)}-${digits.slice(6)}`;
    console.log('Final formatted:', formatted);
    return formatted;
  }
  return phoneNumber;
};
